import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { PerfilPermisosResponse } from '../models/perfil.model';
import { AuthService } from './auth.service';
import { BaseApiService } from './api-base.service';
import { ConfigService } from './config.service';
import { ConfigClientService } from './configClient.service';
import { SINERGIAL_ROUTES } from '../constants/api-sinergial-routes';

@Injectable({ providedIn: 'root' })
export class PerfilService extends BaseApiService<PerfilPermisosResponse> {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    authService: AuthService,
    configClientService: ConfigClientService,
  ) {
    super(http, configService, configClientService, authService);
  }

  getFuncionalidades(
    idUsuario: number,
    idSucursal?: number | null,
  ): Observable<PerfilPermisosResponse> {
    const pathTemplate = SINERGIAL_ROUTES.LOGIN.GET_FUNCIONALIDADES.PATH_REL;

    if (!pathTemplate.includes('{idUsuario}')) {
      return throwError(
        () => new Error('La ruta de funcionalidades no está configurada correctamente.'),
      );
    }

    const path = pathTemplate.replace('{idUsuario}', String(idUsuario));
    const params = idSucursal ? { IdSucursal: idSucursal } : undefined;
    return this.get<PerfilPermisosResponse>(path, { params });
  }
}
